import { ClientDocumentSummary } from '../../Services/InsuranceLicenseService';

type Props = {
	documents?: ClientDocumentSummary[];
	hash: string;
};

export default function InsuranceDocumentLinks(props: Props) {
	const { documents, hash } = props;

	if (!documents || documents.length === 0) {
		return <span>-</span>;
	}

	return (
		<div className="insurance-license-document-links">
			{documents.map((document) => (
				<a
					key={document.ClientDocumentId}
					href={`/u/insurance-license/document/${hash}/${document.ClientDocumentId}`}
					target="_blank"
					rel="noreferrer"
					className="insurance-license-document-link"
				>
					{document.ClientDocumentOriginalFilename}
				</a>
			))}
		</div>
	);
}
